<template>
  <div class="g-container-p">
    <div class="m-container-p">
      <!-- 面包屑 -->
      <div>
        <h3>
          <slot name="title"></slot>
        </h3>
        <div class="node-state"
             style="margin-left:1%;margin-bottom:0.5%;margin-top: 0.5%;">
          <div class="item-state"
               style="padding-left: 1%;padding-bottom:0.5%;padding-bottom:0.5%;"
               v-for="radioData of extrinsicFactorsDataArr"
               :key="radioData.nodeName"
               @change="radioChange">
            <span>{{radioData.nodeName}}</span><br>
            <qe-radio-image-upload :src="src"
                                   :isPic="true"
                                   :picImgs="radioData.picArr"
                                   :nodeName="''"
                                   :subNodeName="radioData.nodeName"
                                   @getDataArrPic="getDataArrPic"
                                   style="width: 80%; padding: 20px 0px 0px 0px;">
              <i slot="del"
                 class="del-p"></i>
            </qe-radio-image-upload>
            <template>
              <el-radio-group v-model="radioData.nodeState"
                              text-color="#626aef"
                              size="small"
                              fill="rgb(239, 240, 253)"
                              style="margin-bottom:1%;margin-top: 0.5%;">
                <el-radio border
                          :label=1>良好</el-radio>
                <el-radio border
                          :label=2>预警</el-radio>
                <el-radio border
                          :label=3>异常</el-radio>
              </el-radio-group>
            </template>
            <div class="create-title-p"
                 style="margin:0px;">
              <input type="text"
                     placeholder="描述"
                     v-model="radioData.remark" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QeRadioImageUpload from './qeRadioImageUpload.vue'

export default {
  name: 'extrinsicFactorsNode',
  data () {
    return {
      src1: require("../../../../../html/pages/originality/createQe/images/upload.jpg"),
      type: '',
      //nodeState 1-良好 2-预警 3-异常
      extrinsicFactorsDataArr: [
        {
          nodeName: "1.风速大于5级时，不得喷涂施工；",
          remark: "",
          nodeState: 0,
          picArr: []
        },
        {
          nodeName: "2.避免夏季高温时段（环境温度＞35℃或地表温度＞40℃）施工，可安排早晚温度较低时段施工作业，以确保施工质量和材料性能；",
          remark: "",
          nodeState: 0,
          picArr: []
        },
        {
          nodeName: "3.环境湿度大于85%或冬季气温低于10℃时，应暂停施工。如确需施工，必须配备烘干设备以加速干燥过程，确保施工效果；",
          remark: "",
          nodeState: 0,
          picArr: []
        },
        {
          nodeName: "4.避免交叉施工导致的污染，合理安排施工顺序和区域，确保施工环境的清洁与独立性。",
          remark: "",
          nodeState: 0,
          picArr: []
        }
      ]
    }
  },
  components: {
    QeRadioImageUpload
  },
  computed: {
    src () {
      return this.src1
    }
  },
  methods: {
    init () {
      this.type = this.$route.query.type
    },
    created () {
      this.init()
    },
    beforeRouteUpdate (to, from, next) {
      next();
      this.init();
    },
    reload () {
      this.uploadReprot(item => {
        window.location.reload()
      })
    },
    radioChange () {
      this.$emit('getExtrinsicFactorsData', this.extrinsicFactorsDataArr);
    },
    getDataArrPic (nodeName, imageName, data) {
      for (let subnode of this.extrinsicFactorsDataArr) {
        if (subnode.nodeName == imageName) {
          subnode.picArr = data
        }
      }
      this.$emit('getExtrinsicFactorsData', this.extrinsicFactorsDataArr);
    },
  },
}
</script>

<style scoped>
</style>
